import { User } from 'api/models';
import { Task } from 'api/tasks';
import { EditorModes, ResourceSection } from 'data/documents';

export interface Document {
  documentId: number;
  accountId: number;
  projectId: number;
  createdBy: number;
  version?: number;
  sections: {
    content: string;
    documentSectionId: number;
    documentId: number;
    createdAt: number;
    createdBy: number;
    updatedAt: number;
    lastUpdatedBy: number;
    versionNumber: number;
    meta: {
      sectionType: 'PRIVATE' | 'PUBLIC';
      resourceSections?: ResourceSection<Partial<Task>>[];
    };
    versioningQueued: boolean;
  }[];
  title: string;
  frozen: boolean;
  frozenAt: string;
  frozenBy: number;
}

export interface DocumentSkelton {
  documentId: number;
  commentThreadId: number;
  accountId: number;
  projectId: number;
  version: number;
  source?: {
    sourceId: number;
    sourceType: DocumentSourceType;
  };
  title: string;
  versioningQueued: boolean;
}

export interface DocumentContainer {
  document: Document;
}

export interface SingleCollaborateSessionExists {
  exists: boolean;
}
export interface EditorCollaborateSessionExists {
  publicDocSession: SingleCollaborateSessionExists;
  privateDocSession: SingleCollaborateSessionExists;
}

export type CollaborationEncodededResponse = string;
export interface DiscussionsContainer {
  discussions: Discussion[];
}

export interface Discussion {
  commentThread: {
    threadId: number;
    resolved?: boolean;
    isPrivate?: boolean;
  };
  private?: boolean;
  comments: Comment[];
}

export interface NewDicussion {
  comment: Comment;
}

export interface Comment {
  commentId: number;
  content: string;
  commentThreadId: number;
  createdAt: number;
  user: User;
  private: boolean;
  documentId: number;
  commentGuid?: string;
  commentMeta?: Record<string, any>;
  resolved?: boolean;
  createdBy: number;
}

enum CommentContextType {
  Document = 'DOCUMENT',
}

enum CommentContextSubType {
  Discussion = 'DISCUSSION',
}

export interface CommentSocketEvent extends Comment {
  commentContext: {
    type: CommentContextType.Document;
    subType: CommentContextSubType.Discussion;
    id: number;
  };
}

export enum DocumentSourceType {
  SpaceTab = 'SPACE_TAB',
  StatusUpdate = 'STATUS_UPDATE',
}

interface VersionInfo {
  id: string;
  name: string;
  diffData: {
    main: {
      deletions: string;
      insertions: string;
    };
  };
  createdAt: string;
  creatorId: string;
  authorIds: string[];
  toVersion: number;
  fromVersion: number;
}

export interface AddVersionPayload {
  documentSectionId: number;
  sectionType: EditorModes;
  content: VersionInfo;
  rocketlaneVersionId: number;
}

export interface DocumentVersion {
  documentSectionId: number;
  documentId: number;
  accountId: number;
  rocketlaneVersionId: string;
  content: VersionInfo;
  createdBy?: number;
}
